module.exports = __webpack_public_path__ + "img/Frond-End-Design.69fc203f.jpg";